import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0","key":"svg-0"}],["path",{"d":"M9 17v-13h10v8","key":"svg-1"}],["path",{"d":"M9 8h10","key":"svg-2"}],["path",{"d":"M19 22v-6","key":"svg-3"}],["path",{"d":"M22 19l-3 -3l-3 3","key":"svg-4"}]]

const IconMusicUp = createReactComponent('outline', 'music-up', 'MusicUp', __iconNode);

export default IconMusicUp;